import {get} from "lodash"
import BaseService from "./Base"
import {CallLogStats, StudentCallLog} from "types/student-call-log"

class StudentCallLogService extends BaseService {
    async list(params): Promise<{total: number; data: StudentCallLog[]}> {
        const response = await this.post("/v1/student-call-logs/list", params)
        return get(response, "data", [])
    }

    async stat(params): Promise<CallLogStats> {
        const response = await this.post("/v1/student-call-logs/stats", params)
        return get(response, "data.data", {})
    }
}

export default StudentCallLogService
